// import LABELS from "labels";
import CONSTANTS from "globalConstants";
import { PROJECT_ANALYTICS } from "redux/constants";

const {
  ERROR_401,
  ERROR_IE,
  ERROR_ENTITLEMENT_API,
  ERROR_CASE_RESTRICTED_MDP,
  ERROR_INVALID_CASE_GUID,
  ENTITLEMENTS: {
    KNOWLEDGE_CONTRIBUTIONS,
    PRODUCTID,
    VIEW,
    CREATE_EDIT_DRAFT,
    PREVIEW_DOWNLOAD,
    PREVIEW_DOWNLOAD_R,
    EDIT_PUBLISHED_CONTENT,
    PUBLISH_CONTENT,
    SHOW_BUNDLE,
    CASE_PAGES,
    VIEW_CASE_DETAIL,
    VIEW_CLIENT_INFO,
    VIEW_BUDGET,
    EDIT,
    EDIT_TOPIC_TAGS,
    VIEW_CASE_MATERIALS,
  },
  VALIDATION_KEY,
  TBDBS: {
    SEARCH_SUBJECT,
    SEARCH_FPA_IPA_INTERNAL,
    FPA,
    IPA,
    BCG_INTERNAL
  },
} = CONSTANTS;

const CONFIG = {
  applicationName: "EEN App",
  TRANSCRIPT_LIBRARY_VERSION: process.env.REACT_APP_VERSION,
  SKELETON_COUNT: [1, 2, 3, 4, 5],
  SERVER_URL: process.env.REACT_APP_FRONTEND_URL,
  ENVIRONMENT_MAIN: process.env.REACT_APP_ENV_MAIN,
  OKTA: {
    ISSUER: process.env.REACT_APP_OKTA_ISSUER,
    REDIRECT_URL:
      "/implicit/callback" /* Must be whitelisted in the Okta client app settings. */,
    CLIENT_ID: process.env.REACT_APP_OKTA_CLIENT_ID,
    ACCESS_TOKEN: "okta-token-storage",
    AUTH_ATTEMPTED: "auth_attempted",
    CACHE_STORAGE: "okta-cache-storage",
    PSID: "psid",
    SMARTLOGIC_TOKEN_KEY: "smartlogic_bearer_token",
    OKTA_PSID: "okta-psId",
    TOKEN_EARLY_EXPIRE: "5"
  },
  ERROR_CONFIG: {
    [ERROR_401]: {
      HEADING: "401",
      MESSAGE: "WE’RE SORRY, YOU DO NOT HAVE SUFFICIENT PRIVILEGES.",
      HELP_TEXT: "Please contact IT service Center to request access.",
      BTN_LABEL: "REQUEST ACCESS",
      BTN_LINK_NEW: true,
      BTN_LINK: "https://bostonconsultinggroup.service-now.com/itconnect?id=sc_cat_item&sys_id=d7f82a12db21d810b7529ec2ca961918",
      WITH_LAYOUT: true,
    },
    [ERROR_IE]: {
      HEADING: "IE11",
      MESSAGE: "WE ARE SORRY, NAVIGATOR DOESN'T SUPPORT INTERNET EXPLORER 11",
      HELP_TEXT: "PLEASE USE CHROME OR MICROSOFT EDGE. BOTH CAN BE INSTALLED FROM YOUR COMPUTER'S SOFTWARE CENTER.",
    },
    [ERROR_ENTITLEMENT_API]: {
      // HEADING: "? ?",
      IMAGE_HEADING: "bulb",
      MESSAGE: "LOOKS LIKE WE ARE EXPERIENCING AN ISSUE!",
      HELP_TEXT: "Please try to refresh the page, if the error still persists then please raise an issue.",
      BTN_LABEL: "REFRESH",
      BTN2_LABEL: "RAISE AN ISSUE",
      WITH_LAYOUT: false,
    },
    [ERROR_CASE_RESTRICTED_MDP]: {
      IMAGE_HEADING: "bulb",
      HELP_TEXT: "Access restricted to MDPs associated with this case!",
    },
    [ERROR_INVALID_CASE_GUID]: {
      IMAGE_HEADING: "bulb",
      HELP_TEXT: "Incorrect URL. Please check the URL and try again.",
    }
  },
  UI_URL: {
    ALL: "*",
    HOME: "/",
    PROJECTANALYTICS: '/projectAnalytics',
    CHAT: "/chat",
    ERRORPATH: "/error",
    REQUEST_FORM: (view) => `/ExpertRequest/${view}`,
    REQUEST_DETAILS: (page) => `/requestDetails/${page}:interviewId?`,
    MANUAL_REVIEW: "/manualreview/:sessionId?",
    TRANCRIPT: "/transcript/:transcriptId?",
    SETTINGS: (page) => `/settings/${page}`,
    // ERROR: (errorCode) => `/error/${errorCode}`,

    CREATION: `/creation`,
    CREATION_KP: `/creation?type=kp`,

    METADATA_KB: (step, kbId) => kbId ? `/kb/metadata/${step}/${kbId}` : step ? `/kb/metadata/${step}` : `/kb/metadata/:step?/:kbId?`,
    METADATA_KP: (step, kpId) => kpId ? `/kp/metadata/${step}/${kpId}/` : step ? `/kp/metadata/${step}` : `/kp/metadata/:step?/:kpid?`,
    METADATA_KP_VALIDATE: (step, kpId) => kpId ? `/kp/metadata/${step}/${kpId}/${VALIDATION_KEY}` : step ? `/kp/metadata/${step}` : `/kp/metadata/:step?/:kpid?`,

    KP_PREVIEW_DETAILS: (kpId) => `/kp/preview/${kpId}`,
    KP_CONSUMPTION: (kpId) => `/kp/${kpId}`,
    KB_PREVIEW: (kbId) => `/kb/preview/${kbId}`,
    KB_CONSUMPTION: (kbId) => `/kb/${kbId}`,
    KP_DOWNLOAD: (appName, type, kpId) => `/download/kp/${appName}/${type}/${kpId}`,

    CP_METADATA: (step, cid) => cid ? `/cases/edit/${step}/${cid}` : step ? `/cases/edit/${step}` : `/cases/edit/:step?/:cid?`,
    CP_CONSUMPTION_NEW: (cid) => `/cases/${cid}`
  },

  API_URL: {
    // Global - Permissions & Entitlements
    GET_ENTITLEMENT: () =>
      `${process.env.REACT_APP_NGEN_API_URL}entitlement/users/public/entitlements`,


    PRIVACY_CONSENT: `${process.env.REACT_APP_API}/privacy-consent`,
    GET_EXPERT_TYPES: `${process.env.REACT_APP_API}/expert-types`,
    POST_INTERVIEW_REQUEST: `${process.env.REACT_APP_API}/expert-interview-requests`,
    GET_NOTIFICATIONS: (hrid) => `${process.env.REACT_APP_API}/notifications?hrId=${hrid}`,
    PUT_INTERVIEW_REQUEST: (interviewRequestId) => `${process.env.REACT_APP_API}/expert-interview-requests/${interviewRequestId}`,
    GET_REQUEST_DETAILS: (interviewRequestId) => `${process.env.REACT_APP_API}/expert-interview-requests/basic/${interviewRequestId}`,
    UPDATE_REQUEST_DETAILS: (interviewRequestId) => `${process.env.REACT_APP_API}/expert-interview-requests/update/${interviewRequestId}`,
    GET_REQUEST_ANALYTICS: (interviewRequestId) => `${process.env.REACT_APP_API}/expert-interview-requests/details/${interviewRequestId}`,
    CLOSE_INTERVIEW_REQUEST: (interviewRequestId, chargeCode) =>
      chargeCode ? `${process.env.REACT_APP_API}/expert-interview-requests/close/${interviewRequestId}?chargeCode=${chargeCode}`
        : `${process.env.REACT_APP_API}/expert-interview-requests/close/${interviewRequestId}`,
    SHARE_VIA_APPROVAL: `${process.env.REACT_APP_API}/communication-templates/email-approval`,
    PROJECT_ANALYTICS: (data) => `${process.env.REACT_APP_API}/expert-interview-requests/chargeCodes?hrId=${data?.hrid}&prefix=${data?.chargeCode}`,
    PROJECT_ANALYTICS_CODES: `${process.env.REACT_APP_API}/project-analytics/chargeCodeCosts`,
    GET_REQUEST_TYPES: `${process.env.REACT_APP_API}/project-types`,
    GET_COMMUNICATION_TEMPLATES: (page, sortBy) => sortBy ? `${process.env.REACT_APP_API}/communication-templates?pageNumber=${page}&pageSize=10&sortBy=${sortBy}` : `${process.env.REACT_APP_API}/communication-templates?pageNumber=${page}&pageSize=10`,
    GET_EXPERT_RECEIVED: (page, sortBy, size) => `${process.env.REACT_APP_API}/expert-profiles?sortBy=${sortBy || 'NewestProfiles'}&size=${size}&page=${page}`,
    GET_DUPLICATE_EXPERTS: (reqID, expName) => `${process.env.REACT_APP_API}/expert-profiles/expert-interview-requests/${reqID}/experts/${expName}/duplicates`,
    GET_PROFILE_COMMENTS: (profileID) => `${process.env.REACT_APP_API}/expert-profiles/${profileID}/comments`,
    GET_EXP_REC_FILTERS: (interviewRequestId) => `${process.env.REACT_APP_API}/expert-profiles/filters?requestId=${interviewRequestId}`,
    GET_CALLS: (page, sortBy) => sortBy ? `${process.env.REACT_APP_API}/calls/by-filters?pageSize=10&pageNumber=${page}&sortBy=${sortBy}` : `${process.env.REACT_APP_API}/calls/by-filters?pageSize=10&pageNumber=${page}`,
    GET_CALLS_FILTERS: (interviewRequestId) => `${process.env.REACT_APP_API}/calls/filters?requestId=${interviewRequestId}`,
    GET_TEMPLATE_FILTERS: (interviewRequestId) => `${process.env.REACT_APP_API}/communication-templates/filters?requestId=${interviewRequestId}`,
    APPROVE_TEMPLATES: `${process.env.REACT_APP_API}/communication-templates/approval`,
    EDIT_TEMPLATE: `${process.env.REACT_APP_API}/communication-templates`,
    DISPUTE_CALL: `${process.env.REACT_APP_API}/calls/dispute`,
    UPCOMING_CALLS: (interviewRequestId, page, size) => `${process.env.REACT_APP_API}/calls?requestId=${interviewRequestId}&size=3&page=${page}&status=Upcoming`,
    DOWNLOAD_EXPERTS: (interviewRequestId) => `${process.env.REACT_APP_API}/expert-profiles?requestId=${interviewRequestId}`,
    NO_ACCESS: `${process.env.REACT_APP_API}/request-access/email`,
    CANCEL_CALL: `${process.env.REACT_APP_API}/calls/cancel`,
    GET_CHARGE_CODES: (payload) =>
      payload?.nextPageToken !== undefined ?
        `${process.env.REACT_APP_API}/finance-data/charge-codes/${payload?.searchString || ''}?nextPageTag=${payload?.nextPageToken}` : `${process.env.REACT_APP_API}/finance-data/charge-codes/${payload?.searchString !== "" ? payload?.searchString : '00'}`,
    GET_CHARGE_CODES_DETAILS: (payload) => `${process.env.REACT_APP_API}/finance-data/charge-codes/details/${payload}`,
    SET_PROFILE_ACTION: `${process.env.REACT_APP_API}/expert-profiles/actions`,
    POST_SURVEY_REQUEST: `${process.env.REACT_APP_API}/expert-survey-requests`,
    GET_EXTERNAL_NETWORKS: `${process.env.REACT_APP_API}/external-expert-providers`,
    // Global - Profile/People API
    GET_PEOPLE: `${process.env.REACT_APP_API_PEOPLE}/domain/v2/people`,
    UPLOAD_FILE_URL: (filename, guid) => `${process.env.REACT_APP_UPLOAD_API}upload/${guid}/${filename}`,
    // GET_PRESIGNED: (filename, guid) =>
    //   `https://api-kd-test.integration.smp.bcg.com/externalexpertshub/s3/signedUrlForFileUpload?fileName=${filename}&bucketName=openai-searchable-externalexperts-dev&dir=1`,
    LINK_PROFILE_REDIRECT: (hrid) => `${process.env.REACT_APP_PROFILE_LINK}/overview?hrid=${hrid}`,
    LINK_PAGES_REDIRECT: 'https://pages.navigator.bcg.com',
    GET_FILE_API: (documentID, fileName, s3Bucket, s3Object) => `${process.env.REACT_APP_TL_SMP_URL}/download/v2/${documentID}/document?type=Transcript_Library&appName=Transcript_Library&fileName=${encodeURIComponent(fileName)}&s3Bucket=${s3Bucket}&s3Object=${s3Object}`,
    GET_DOWNLOAD_COUNT_API: (documentID) => `${process.env.REACT_APP_TL_SMP_URL}/download/documents/count?docIds=${documentID}`,
    GET_SMARTLOGIC_TOKEN: `${process.env.REACT_APP_SMARTLOGIC_API}/token`,
    GET_TYPESEARCH_DATA: (key, term) => `${process.env.REACT_APP_SMARTLOGIC_API}/svc/${process.env.REACT_APP_SMARTLOGIC_TYPESEARCH_API_KEY}/ses/?TBDB=${key}&service=prefix&term_prefix=${term}&template=service.json`,
    GET_SL_PARENT_TAGS: (key, ids) => `${process.env.REACT_APP_SMARTLOGIC_API}/svc/${process.env.REACT_APP_SMARTLOGIC_TYPESEARCH_API_KEY}/ses/?TBDB=${key}&service=browse&id=${ids}&template=service.json`,
    // To check if the logged in user is site admin/editor or not
    SITE_ADMIN_EDITOR: `${process.env.REACT_APP_SITECORE_API_URL}api/Knowledge/User/InRole`,

    //Clipping
    GET_CLIPPING_STATUS: (appName, id) => `${process.env.REACT_APP_TL_SMP_PRIVATE_URL}/clipfile/status/${id}?appName=${appName}`,
    CLIP_FILE: (appName, documentID, totalPages, s3Object) => `${process.env.REACT_APP_TL_SMP_PRIVATE_URL}/clipfile/clippingrequest?appName=${appName}&documentID=${documentID}&totalPages=${totalPages}&s3Object=${s3Object}`,
    INTERNAL_API: `${process.env.REACT_APP_TL_INTERNAL_API}/transcriptlibrary/api/v1.0/TranscriptLibrary/GetDocvizConversionStatus`,
    GET_TRANSCRIPT_DETAIL_API: (id) => `${process.env.REACT_APP_TL_INTERNAL_API}/getmetadata/transcript/details/${id}`,
    DELETE_FILE: `${process.env.REACT_APP_API}/s3/deleteFile`,
    RENAME_FILE: `${process.env.REACT_APP_API}/s3/renameFile`,
    POST_CALL_SLOTS: `${process.env.REACT_APP_API}/calls`,
  },
  USABILLA: {
    BUTTON_ID: "d0d0c7d779ff",
    MAPPING_SURVERY: {
      KP_PUBLISH: "a28c512331f4",
      CONSUMPTION_RATING: "bfa185fc00c0",
    },
    GET_USABILLA_NAME: (buttonId, analyticId) => `usbl.${buttonId}.c.${analyticId}`,
  },

  PEOPLE_API_X_API_KEY: process.env.REACT_APP_PEOPLE_API_X_API_KEY,
  X_API_KEY: process.env.REACT_APP_API_KEY,
  SMARTLOGIC_KEY: process.env.REACT_APP_SMARTLOGIC_KEY,

  BE_X_API_KEY: process.env.REACT_APP_API_KEY,

  GUIDED_TOUR_IDS: {
    prod_publisher_id: "678a3b795cac543a4f4614b4",
    preprod_publisher_id: "678f7f96b8e999f826aa60e2",
    prod_consent_form: "67c1a560e43c2bc83148ab0d",
    preprod_consent_form: "67b2cca7e818bc036ccd63d5",
    prod_request_form: "67c1a9652addab37103de646",
    preprod_request_form: "67b2d1ade818bc036ccd64fb",
    prod_home_new_user: "67c1a62ce43c2bc83148ab88",
    preprod_home_new_user: "67b2d012e818bc036ccd644d",
    prod_home_old_user: "67c04c3e03fc1a4a082a84a7",
    preprod_home_old_user: "67a5abb34fd934595ad26ecf",

    preprod_req_details_tabs: ['67b2d21b71e6d4f5ad97c29d', '67b2d26d71e6d4f5ad97c2c1', '67b2d2f1e818bc036ccd6551', '67b2d505e818bc036ccd6599'],
    prod_req_details_tabs: ['67c1a6ab2addab37103de53f', '67c1a76a03fc1a4a082a8ad7', '67c1a81f2addab37103de608', '67c1a9b62addab37103de674']
    
  },

  HTTP_CONTENT_TYPES: {
    json: "application/json",
    image: "image/jpeg",
    urlencoded: "application/x-www-form-urlencoded;charset=utf-8"
  },
  ENTITLEMENTS: {
    [KNOWLEDGE_CONTRIBUTIONS]: {
      [PRODUCTID]: 1,
      [VIEW]: 1,
      [CREATE_EDIT_DRAFT]: 2,
      [PREVIEW_DOWNLOAD]: 3,
      [PREVIEW_DOWNLOAD_R]: 4,
      [EDIT_PUBLISHED_CONTENT]: 5,
      [PUBLISH_CONTENT]: 6,
      [SHOW_BUNDLE]: 18
    },
    [CASE_PAGES]: {
      [PRODUCTID]: 2,
      [VIEW]: 7,
      [VIEW_CASE_DETAIL]: 8,
      [VIEW_CLIENT_INFO]: 9,
      [VIEW_BUDGET]: 10,
      [EDIT]: 11,
      [EDIT_TOPIC_TAGS]: 12,
      [VIEW_CASE_MATERIALS]: 13
    },
  },
  BEARER: "Bearer ",
  PEOPLE_API_QUERY_PARAMS: {
    DEFAULT: {
      LIMIT: 500,
      OFFSET: 0,
      REQUEST_DATA: "id staffId title firstName picture lastName displayName jobFunction globalTitle email name alumni hostOfficeLocation { id name regionId street street2 street3 city state zipCode country countryCode }"
    },
    CASE_CONTACT_SEARCH: {
      LIMIT: 500,
      REQUEST_DATA: "id firstName lastName alumni staffId"
    },
    AUTHORS_LISTING: {
      REQUEST_DATA: "id firstName lastName alumni staffId"
    }
  },
  SORT: {
    ASC: "ASC",
    DESC: "DESC"
  },
  DISPLAY_TEXT: {
    DEFAULT_ERROR: {
      TITLE: 'Oops, something went wrong!',
      MESSAGE: 'Something went wrong, please try again.'
    },
    ERROR_MESSAGES: {
      AUTH_FAILED: 'Authentication failed.',
      NOT_FOUND: 'The server could not find the data',
      FORBIDDEN: 'You do not have permissions to view this content',
      UNKNOWN_CODE: 'The server returned an unknown HTTP error code.',
      SERVER_ERROR: 'There was an external server error',
      NETWORK_ERROR: 'There was a network error.',
      REQUEST_CANCELLED: 'The request was cancelled.',
    }
  },
  API_KEYS: {
    UPLOAD_API_KEY: process.env.REACT_APP_UPLOAD_API_KEY,
    SMARTLOGIC_API_KEY: process.env.REACT_APP_SMARTLOGIC_API_KEY,
    SMP_API_KEY: process.env.REACT_APP_TL_SMP_API_KEY
  },
  POLY_HIERARCHICAL: process.env.REACT_APP_IS_POLY_ENABLED?.trim() === "true" ? [
    [
      { id: 'f7c063b3-e271-4130-ba40-54d4837aed2c', type: FPA },
      { id: '7fb35b48-257e-48e0-8991-7d5d678e3a23', type: FPA },
    ],
    [
      { id: '1db52330-f2db-45c4-93c0-85b376e594d9', type: FPA },
      { id: '33dbebf1-a9cc-4ad1-acd7-e829569d426a', type: FPA }
    ],
    [
      { id: 'b029ec4c-9bfc-432b-b0c7-807e577be6de', type: FPA },
      { id: 'b1b4b264-15e3-4f1d-af94-e5a62cde8126', type: FPA }
    ],
    [
      { id: '2307d865-a507-4d32-b684-d550f46761e0', type: FPA },
      { id: '5b9972bf-f202-4c33-bc75-75ad10f80299', type: FPA }
    ],
    [
      { id: '157c0d07-6a06-4cd7-9b39-8f2b621e31f4', type: FPA },
      { id: '933fe0db-c7b2-4cf3-9a85-38bb148a905f', type: FPA }
    ],
    [
      { id: 'e313dc31-16a1-417e-8c3f-dfcce429b98f', type: FPA },
      { id: '6d0059ae-a1c1-4503-b0e7-321287796980', type: FPA }
    ],
    [
      { id: 'fdabb807-c7c4-4ead-a499-d048007e5b17', type: FPA },
      { id: '7e4c03fe-e8b1-4521-8ea0-22893836e554', type: FPA }
    ],
    [
      { id: '9d49ed74-9291-4063-af11-f8ff02357f6d', type: IPA },
      { id: 'bc15e37b-78b1-4395-854c-ef31ff21f30e', type: IPA }
    ],
    [
      { id: 'c31ce2c8-5cdd-48df-94ba-325343561989', type: IPA },
      { id: 'c9c6267e-4e90-4447-ae38-b33b13f99245', type: IPA }
    ],
    [
      { id: 'e27ec256-12ba-46d5-a59e-a785a0105ac9', type: IPA },
      { id: 'fc6583b4-28cb-4ccf-a1d2-f676a4022d3b', type: IPA }
    ]
  ] : [],
  TAXONOMY_IDS: {
    IPA: () => `${process.env.REACT_APP_TAXONOMY_IPA}`,
    FPA: () => `${process.env.REACT_APP_TAXONOMY_FPA}`,
    BCG_INTERNAL: () => `${process.env.REACT_APP_TAXONOMY_BCG_INTERNAL}`,
    SUBJECT: () => `${process.env.REACT_APP_TAXONOMY_SUBJECT}`,
    TOPICPAGE_IPA: () => `${process.env.REACT_APP_TAXONOMY_TOPICPAGE_IPA}`,
    TOPICPAGE_FPA: () => `${process.env.REACT_APP_TAXONOMY_TOPICPAGE_FPA}`,
    REGIONS_COUNTRIES: () => `${process.env.REACT_APP_TAXONOMY_REGIONSCOUNTRIES}`,
    GLOBAL_REGION: "fb57a427-7b3f-44c1-938a-4d55c52f500e",
    GLOBAL_INTERNAL_OFFICE: "fab65ff9-cfc0-4401-8dc5-197fc9e608f0",
    IGNOREGUIDS_BST: [
      "19cc6dd8-e933-4c5d-9898-594fc77498b9", //IPA
      "56779bc7-52a4-4b26-a1f3-6f6560d028ec", //FPA
      "ecdf3e3b-c78f-4de4-9f6e-f9d798db4ddd"
    ]
  },
  MAIL_TO_LABEL: (label) =>
    label ? ["subject", "ipa", "fpa"].includes(label.toLowerCase()) : false,
  MAIL_TO: (mode = true) => ({
    text: mode
      ? "Have questions related to Taxonomy"
      : "Can’t find the right Search and Discovery tag?",
    buttonText: "Contact us",
    email: "TaxonomyDevSupport@bcg.com",
    subject: "Request for new taxonomy term addition",
  }),

  DOWNLOAD_APPLICATION_NAME: {
    KNOWLEDGE_PAGE_APP_NAME: 'Transcript_Library'
  },
};

export default CONFIG;


